import * as React from "react"
import Main from "../../components/atoms/Main/Main";

import {StaticImage} from "gatsby-plugin-image";
import MainNav from "../../components/molecules/MainNav/MainNav";

// markup
const IndexPage = () => {
  return (
    <Main
      poll
      footerContent={(
      <MainNav active="chat"/>
    )}>
      <div></div>
      <StaticImage src="../../images/app/chat.png" alt="" layout="fullWidth"/>
    </Main>
  )
}

export default IndexPage
